import React from 'react';
import PropTypes from 'prop-types';

/**
 * Just a div to add some space instead of using margins.
 */

const DEFAULT_HEIGHT = 32;
const DEFAULT_WIDTH = 32;

const Spacer = ({ size = 1, horizontal = false }) => {
  let style;
  if (horizontal) {
    style = { width: DEFAULT_WIDTH * size };
  } else {
    style = { height: DEFAULT_HEIGHT * size };
  }

  return <div css={style} />;
};

Spacer.propTypes = {
  /**
   * Ratio to multiply the default height value
   */
  size: PropTypes.number,
  /**
   * Whether the spacer is for width
   */
  horizontal: PropTypes.bool
};

export default Spacer;
